import React from "react";
import {
  Stethoscope,
  Heart,
  FileText,
  Users,
  Shield,
  Activity,
  Pill,
  Video,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Telemedicine Platforms",
    description:
      "Build secure video consultation and remote patient monitoring systems",
    icon: Video,
  },
  {
    title: "EHR/EMR Systems",
    description:
      "Develop electronic health record systems with seamless data management",
    icon: FileText,
  },
  {
    title: "Patient Engagement Apps",
    description:
      "Create mobile apps for appointment booking, health tracking, and communication",
    icon: Users,
  },
  {
    title: "Clinical Decision Support",
    description:
      "Implement AI-powered diagnostic assistance and treatment recommendations",
    icon: Activity,
  },
  {
    title: "Healthcare Analytics",
    description:
      "Build dashboards for population health management and outcomes analysis",
    icon: Stethoscope,
  },
  {
    title: "HIPAA Compliance",
    description:
      "Ensure data security and regulatory compliance across all healthcare solutions",
    icon: Shield,
  },
  {
    title: "Pharmacy Management",
    description:
      "Develop prescription management and medication tracking systems",
    icon: Pill,
  },
  {
    title: "Remote Monitoring",
    description:
      "IoT-enabled solutions for continuous patient health monitoring",
    icon: Heart,
  },
];

const STATS = [
  { value: "100+", label: "Healthcare Apps" },
  { value: "5M+", label: "Patients Served" },
  { value: "HIPAA", label: "Compliant" },
  { value: "24/7", label: "Support" },
];

const HealthcareIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="healthcare-medical"
      industryTitle="Healthcare"
      industrySubtitle="& Medical"
      heroDescription="Transforming patient care through innovative digital health solutions, telemedicine platforms, and intelligent healthcare management systems that improve outcomes and accessibility."
      themeColor="#0891b2"
      themeColorLight="#22d3ee"
      themeGradient="linear-gradient(135deg, #164e63 0%, #0e7490 50%, #0891b2 100%)"
      HeroIcon={Stethoscope}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?q=80&w=1106&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default HealthcareIndustryPage;
